import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-navy-950 text-white">
      {/* Main Footer */}
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-8 h-8 bg-brand-500 rounded-lg flex items-center justify-center">
                <svg className="w-5 h-5 text-white" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M13 7h8m0 0v8m0-8l-8 8-4-4-6 6" />
                </svg>
              </div>
              <span className="text-lg font-bold">
                Swing Trader <span className="text-brand-400">Edge</span>
              </span>
            </div>
            <p className="text-navy-400 text-sm leading-relaxed">
              AI-powered signal intelligence for swing traders. Simplify your analysis. Sharpen your timing.
            </p>
          </div>
          
          {/* Product */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-navy-300 mb-4">Product</h3>
            <ul className="space-y-3">
              <li><Link to="/dashboard" className="text-navy-400 hover:text-brand-400 text-sm transition-colors">Dashboard</Link></li>
              <li><Link to="/" className="text-navy-400 hover:text-brand-400 text-sm transition-colors">Signal Score</Link></li>
              <li><Link to="/" className="text-navy-400 hover:text-brand-400 text-sm transition-colors">Pricing</Link></li>
            </ul>
          </div>
          
          {/* Resources */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-navy-300 mb-4">Resources</h3>
            <ul className="space-y-3">
              <li><Link to="/" className="text-navy-400 hover:text-brand-400 text-sm transition-colors">How It Works</Link></li>
              <li><Link to="/" className="text-navy-400 hover:text-brand-400 text-sm transition-colors">FAQ</Link></li>
              <li><Link to="/" className="text-navy-400 hover:text-brand-400 text-sm transition-colors">Blog</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-semibold uppercase tracking-wider text-navy-300 mb-4">Contact</h3>
            <p className="text-navy-400 text-sm">
              Questions or feedback?
            </p>
            <a 
              href="mailto:support@swingtraderedge.ai" 
              className="text-brand-400 hover:text-brand-300 text-sm transition-colors"
            >
              support@swingtraderedge.ai
            </a>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-navy-800">
        <div className="container mx-auto px-4 py-4 flex flex-col sm:flex-row justify-between items-center">
          <p className="text-navy-500 text-xs">
            &copy; {currentYear} Swing Trader Edge. All rights reserved.
          </p>
          <div className="flex space-x-6 mt-2 sm:mt-0">
            <Link to="/" className="text-navy-500 hover:text-navy-300 text-xs transition-colors">Privacy Policy</Link>
            <Link to="/" className="text-navy-500 hover:text-navy-300 text-xs transition-colors">Terms of Service</Link>
          </div>
        </div>
      </div>

      {/* Disclaimer */}
      <div className="border-t border-navy-800">
        <div className="container mx-auto px-4 py-3">
          <p className="text-navy-600 text-xs text-center leading-relaxed">
            Swing Trader Edge is a decision-support tool. It does not provide financial advice. 
            Past performance and signal scores do not guarantee future results. Always do your own research before making investment decisions.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
